/**
 * 이미지 업로드 가능 확장자
 * @type {string[]}
 */
export const POSSIBLE_IMAGE_EXT = [
    'pdf', 'png', 'jpg', 'jpeg', 'gif',
];

/**
 * 이미지 업로드 가능 용량
 * @type {number}
 */
export const MAX_IMAGE_SIZE = 12 * 1024 * 1024;

/**
 * 이미지 업로드 가능 기본 갯수
 * @type {number}
 */
export const MAX_IMAGE_DEFAULT_COUNT = 5;
